export enum Breakpoint {
	XS = 'XS',
	SM = 'SM',
	MD = 'MD',
	LG = 'LG',
	XL = 'XL',
}

export const BreakpointWidths = {
	SM: 600,
	MD: 768,
	LG: 1024,
	XL: 1440,
};

export const getCurrentBreakpoint = (windowWidth?): Breakpoint => {
	const currentWidth = windowWidth || window.innerWidth;

	if (currentWidth < BreakpointWidths.SM) {
		return Breakpoint.XS;
	} else if (currentWidth < BreakpointWidths.MD) {
		return Breakpoint.SM;
	} else if (currentWidth < BreakpointWidths.LG) {
		return Breakpoint.MD;
	} else if (currentWidth < BreakpointWidths.XL) {
		return Breakpoint.LG;
	} else {
		return Breakpoint.XL;
	}
};
